(
    function (skyward, $, undefined)
    {
        skyward.careerplan = skyward.careerplan || {};

        var Module;
        var LatestTimeTransactionID;

        var init = function (selector)
        {
            if ($(selector).find(".careerPlanDisplay").length > 0)
            {
                var parent = $(selector).find(".careerPlanDisplay");
                
                skyward.careerplan.initTabs(selector);

                $(parent).find('[id^=careerPlanSummaryButton]').on('click', skyward.careerplan.showCareerPlanSummary);
                $(parent).find('[id^=plannedCurriculumButton]').on('click', skyward.careerplan.showPlannedCurriculum);

                $(parent).find('#RequirementStatus').on('change', skyward.careerplan.filterCareerPlanSummary);
                $(parent).find('#GradeLevelFilter').on('change', skyward.careerplan.filterGradeLevels);

                $(parent).find('a.addCurriculumWithGradeLevel').on('click', function () { addCurriculumByGradeLevel(selector) });

                $(parent).find('a.confirmFourYearPlan').on('click', function () { confirmFourYearPlan(selector) });
            }

            if ($(selector).find("#careerplanaddworkflow").length > 0)
            {
                var parent = $(selector).find("#careerplanaddworkflow");
                
                $(parent).find('#StudentCareerPlan.CareerPlanGradeLevelID').on('change', skyward.careerplan.buildCurriculumCodeEEL);
                $(parent).find('#StudentCareerPlan.StudentSubAreaID').on('change', skyward.careerplan.buildCurriculumCodeEEL);
            }
        };

        skyward.careerplan.initTabs = function (parent)
        {
            var currentTab = skyward.controls.getValue($(parent).find('#currentTab'));
            
            $(parent).find(".careerPlanDisplay").each(function ()
            {
                var wrapper = $(this);
                var primaryKey = wrapper.find('#careerPlanTabs').data('modelprimarykey');
                if (currentTab === "plannedCurriculumButton") {
                    skyward.controls.hide('careerPlanSummaryContent-' + primaryKey);
                    skyward.controls.show('plannedCurriculumContent-' + primaryKey);
                    $(wrapper).find('#plannedCurriculumButton-' + primaryKey).addClass('activeCareerPlanTab');
                }
                else {
                    skyward.controls.show('careerPlanSummaryContent-' + primaryKey);
                    skyward.controls.hide('plannedCurriculumContent-' + primaryKey);
                    $(wrapper).find('#careerPlanSummaryButton-' + primaryKey).addClass('activeCareerPlanTab');
                }
            });
        };

        skyward.careerplan.showCareerPlanSummary = function ()
        {
            var clickedButton = $(this);
            var parent = clickedButton.parent();
            var outerWrapper = clickedButton.parents('.careerPlanDisplay');
            var primaryKey = outerWrapper.find('#careerPlanTabs').data('modelprimarykey');
            var type = outerWrapper.data('type');
            skyward.controls.show('careerPlanSummaryContent-' + primaryKey);
            skyward.controls.hide('plannedCurriculumContent-' + primaryKey);
            parent.find('.careerPlanTab').removeClass('activeCareerPlanTab');
            clickedButton.addClass('activeCareerPlanTab');
            var browseid = "StudentPlan";
            var modelPrimaryKey = parent.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "")
            {
                browseid = browseid + "-" + primaryKey;
            }
            var browse = skyward.browse.browseList[browseid];

            if (browse)
            {
                skyward.browse.get(browseid, browse.data);
                skyward.detailsPanel.closeDetailsPanel();
            }
            
            var postData =
                {
                    Tab: "careerPlanSummaryButton"
                };
            var actionPath = "GraduationRequirements/StudentCareerPlan/SetTab" + type;

            $.ajax(
            {
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                data: postData                
            });
        };

        skyward.careerplan.showPlannedCurriculum = function ()
        {
            var clickedButton = $(this);
            var parent = clickedButton.parent();
            var outerWrapper = clickedButton.parents('.careerPlanDisplay');
            var primaryKey = outerWrapper.find('#careerPlanTabs').data('modelprimarykey');
            var type = outerWrapper.data('type');
            skyward.controls.hide('careerPlanSummaryContent-' + primaryKey);
            skyward.controls.show('plannedCurriculumContent-' + primaryKey);
            parent.find('.careerPlanTab').removeClass('activeCareerPlanTab');
            clickedButton.addClass('activeCareerPlanTab');
            var browseid = "StudentCareerPlans";
            var modelPrimaryKey = parent.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "")
            {
                browseid = browseid + "-" + primaryKey;
            }
            var browse = skyward.browse.browseList[browseid];
            skyward.browse.get(browseid, browse.data);
            skyward.detailsPanel.closeDetailsPanel();

            var postData =
            {
                Tab: "plannedCurriculumButton"
            };
            var actionPath = "GraduationRequirements/StudentCareerPlan/SetTab" + type;

            $.ajax(
            {
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData
            });

        };

        skyward.careerplan.filterCareerPlanSummary = function ()
        {
            var clickedButton = $(this);
            var parent = clickedButton.parent();
            var filter = parent.find("#" + skyward.controls.getValue(clickedButton));
            var browseid = "StudentPlan";
            var modelPrimaryKey = parent.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "") {
                browseid = browseid + "-" + parent.data("modelprimarykey");
            }
            skyward.browse.changeFilter(browseid, { browseFilterId: skyward.controls.getValue(filter) });
        };

        skyward.careerplan.filterGradeLevels = function ()
        {
            var clickedButton = $(this);
            var parent = clickedButton.parent();
            var buttonValue = skyward.controls.getValue(clickedButton);
            
            var filter;
            
            var browseid = "StudentCareerPlans";
            var modelPrimaryKey = parent.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "") {
                browseid = browseid + "-" + parent.data("modelprimarykey");
            }

            if (buttonValue === 'AllGradesFilter')
            {
                filter = buttonValue;                
            }
            else
            {
                var browse = skyward.browse.browseList[browseid];
                browse.data.GradeLevelFilterID = buttonValue;
                var option = clickedButton.find(':selected');

                if (option.data('isprior') === true)
                {
                    filter = 'PriorFilter';
                }
                else
                {
                    filter = 'EqualFilter';
                }
            }
            skyward.browse.changeFilter(browseid, { browseFilterId: skyward.controls.getValue($('#' + filter)) });
        };

        skyward.careerplan.buildCurriculumCodeEEL = function () {
            var clickedButton = $(this);
            var parent = clickedButton.parents("#careerplanaddworkflow");
            var isAdminAccess = skyward.controls.getValue(parent.find('#isAdminAccess'));
            var careerPlanGradeLevel = skyward.controls.getValue(parent.find('#StudentCareerPlan.CareerPlanGradeLevelID'));
            var studentSubAreaID = skyward.controls.getValue(parent.find('#StudentCareerPlan.StudentSubAreaID'));
            var curriculumID = skyward.controls.getValue(parent.find('#CurriculumID'));

            var action = "BuildCurriculumCodeEEL";

            if (isAdminAccess === true || isAdminAccess == "True")
            {
                action = action + "AdministrativeAccess";
            }
            else
            {
                action = action + "StudentAccess";
            }

            $.ajax(
                {
                url: skyward.global.virtualDir + "GraduationRequirements/StudentCareerPlan/" + action,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    CareerPlanGradeLevelID: careerPlanGradeLevel,
                    StudentSubAreaID: studentSubAreaID,
                    CurriculumID: curriculumID
                },
                success: function (returnData) 
                {                    
                    parent.find('#curriculumCodeEEL').html(returnData);  
                    parent.find('#CurriculumID').each(function () 
                    {
                        skyward.codeeel.registerCodeEEL($(this));
                    });
                }
            });
        };

        var confirmFourYearPlan = function (parent)
        {
            var action;
            var browseid = "StudentCareerPlans";
            var clickedButton = $(parent).find('a.confirmFourYearPlan');
            var parentBrowse = clickedButton.parent();
            var modelPrimaryKey = parentBrowse.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "")
            {
                browseid = browseid + "-" + parentBrowse.data("modelprimarykey");
            }

            var browse = skyward.browse.browseList[browseid];
            var browsedata = browse.data;
            var browseStudentData = browsedata["Workflow.StudentCareerPlan.StudentID"];
            var isAdminAccess = browsedata["IsAdminAccess"];            
            var isFamilyAccess = browse.data["Workflow.IsFamilyAccess"];

            if (isAdminAccess === true || isAdminAccess == "True")
            {
                action = "Add";
            }
            else if (isFamilyAccess === true || isFamilyAccess == "True")
            {
                action = "FamilyAccessAdd";
            }
            else 
            {
                action = "StudentAccessAdd";
            }

            var test1 = browse.data["Workflow.schoolyearid"];
            var test2 = browse.data["Workflow.SchoolYearID"];

            if (test1 === test2)
            {
                action = "add";
            }

            if (isAdminAccess === true || isAdminAccess == "True")
            {
                skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/GraduationRequirements/StudentCareerPlanSummary/' + action, null,
                    {
                        "Workflow.EntityID": browse.data["Workflow.EntityID"],
                        "Workflow.SchoolYearID": browse.data["Workflow.SchoolYearID"],
                        "Workflow.StudentCareerPlanSummary.StudentID": browseStudentData.toString(),
                        "Workflow.StudentCareerPlanSummary.StudentID_securityhash": browse.data["Workflow.StudentCareerPlanSummary.studentID_securityhash"],
                        "Workflow.UserNameID": browse.data["Workflow.UserNameID"],
                        "Workflow.UserNameID_securityhash": browse.data["Workflow.UserNameID_securityhash"],
                    }, null, null, null, false, null, null, null); return false;
            }
            else
            {
                skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/GraduationRequirements/StudentCareerPlanSummary/' + action, null,
                    {
                        "Workflow.EntityID": browse.data["Workflow.EntityID"],
                        "Workflow.SchoolYearID": browse.data["Workflow.SchoolYearID"],
                        "Workflow.IsStudentAccess": browse.data["Workflow.IsStudentAccess"],
                        "Workflow.IsFamilyAccess": browse.data["Workflow.IsFamilyAccess"],
                        "Workflow.StudentCareerPlanSummary.StudentID": browseStudentData.toString(),
                        "Workflow.StudentCareerPlanSummary.StudentID_securityhash": browse.data["Workflow.StudentCareerPlanSummary.studentID_securityhash"],
                        "Workflow.UserNameID": browse.data["Workflow.UserNameID"],
                        "Workflow.UserNameID_securityhash": browse.data["Workflow.UserNameID_securityhash"],
                    }, null, null, null, false, null, null, null); return false;
            }
        }

        var addCurriculumByGradeLevel = function (parent)
        {
            if ($(this).hasClass('ui-disabled')) return false;

            var action;
            var browseid = "StudentCareerPlans";
            var clickedButton = $(parent).find('select.addCurriculumWithGradeLevelFilter');
            var parentBrowse = clickedButton.parent();
            var modelPrimaryKey = parentBrowse.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "")
            {
                browseid = browseid + "-" + parentBrowse.data("modelprimarykey");
            }

            var gradeLevelFilter = $(parent).find('select.addCurriculumWithGradeLevelFilter');
            var buttonValue = skyward.controls.getValue(gradeLevelFilter);
            var filter;

            if (buttonValue === 'AllGradesFilter')
            {
                filter = buttonValue;
            }
            else
            {
                var option = gradeLevelFilter.find(':selected');

                if (option.data('isprior') === true)
                {
                    filter = 'PriorFilter';
                }
                else
                {
                    filter = 'EqualFilter';
                }
            }

            var browse = skyward.browse.browseList[browseid];
            var browsedata = browse.data;
            var browseStudentData = browsedata["Workflow.StudentCareerPlan.StudentID"];
            var isAdminAccess = browsedata["IsAdminAccess"];

            if (isAdminAccess === true || isAdminAccess == "True")
            {
                action = "Add";
            }
            else
            {
                action = "StudentAccessAdd";
            }

            skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/GraduationRequirements/StudentCareerPlan/' + action, null,           
                {
                    "Workflow.StudentCareerPlan.StudentID": browseStudentData.toString(), 
                    "Workflow.DistrictIDFilter": browse.data["Workflow.DistrictIDFilter"], 
                    "Workflow.StudentCareerPlan.StudentID_securityhash": browse.data["Workflow.StudentCareerPlan.studentID_securityhash"],
                    "Workflow.DistrictIDFilter_securityhash": browse.data["Workflow.districtIDFilter_securityhash"],
                    "Workflow.GradeLevelLiteral": gradeLevelFilter.val(),    
                    "Workflow.GradeLevelFilterType": filter,                    
                }, null, null, null, false, null, null, null); return false;
        }


        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
